import React from 'react';
import {Route} from 'react-router-dom';
import {FormattedHTMLMessage, FormattedMessage} from "react-intl";
import TransitionContainer from "@ignitesales/neuro-application/src/components/TransitionContainer";
import ProgressBar from "./ProgressBar";
import MessageIfPresent from "@ignitesales/neuro-application/src/components/MessageIfPresent";

const Sidebar = ({ currentPage, progress }) => {
  const cssBEM = "sidebar";
  const pathKey = currentPage?.path?.key || '';
  const messageId = `sidebar.${pathKey}.text`;

  return (
    <Route path={["/guide/spa/:uuid/:path/:page"]} children={({match}) => {
      return match && currentPage ? <div className={cssBEM}>
        <TransitionContainer className="sidebarTransitionContainer" transitionKey={pathKey}>
          <div className={`${cssBEM}__container`}>
            <div className={`${cssBEM}__image pathImage-${pathKey}`} />
            <div className={`${cssBEM}__text`}>
              <FormattedMessage id="guide.name" tagName="h5" />
              <MessageIfPresent id={messageId}>
                <FormattedHTMLMessage id={messageId} tagName="h4" />
              </MessageIfPresent>
            </div>
          </div>
        </TransitionContainer>
        <ProgressBar progress={progress}/>
      </div> : null
    }}/>
  )
};

export default Sidebar;
